import Multistep from './Multistep'
import Multioption from './Multioption'

export default {
  multistep: Multistep,
  multistep_multioption: Multioption,
}
